module.exports = __webpack_public_path__ + "img/35.245d0ae6.jpg";